import AppImage from '@theme/components/atom/AppImage'

export default {
  components: {
    AppImage,
  },
  props: {
    author: {
      type: Object,
      required: true,
    },
  },
}
